import { render, staticRenderFns } from "./DataField.vue?vue&type=template&id=e6eedcfa&scoped=true&"
import script from "./DataField.ts?vue&type=script&lang=ts&"
export * from "./DataField.ts?vue&type=script&lang=ts&"
import style0 from "./DataField.scss?vue&type=style&index=0&id=e6eedcfa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6eedcfa",
  null
  
)

export default component.exports